import { html } from "lit";
import {
    dummyEvents,
    TeaserEventTemplate,
} from "../../../partial-templates/teaser/event/teaser-event.templates";
import { ViewAllBlockTemplate } from "./view-all.templates";

export const EventSliderTemplate = ({ tab = "events" }) => html`
    <ux-slider
        breakpoint-s="767"
        breakpoint-m="1023"
        breakpoint-l="1440"
        visible-slides-s="1"
        visible-slides-m="1"
        visible-slides-l="2"
        visible-slides-xl="3"
        space-between-s="10"
        space-between-m="30"
        space-between-l="30"
        space-between-xl="30"
        slides-per-group-l="3"
        slides-per-group-xl="3"
        container-classes="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1 ux-u-margin-bottom-5 ux-u-margin-m-bottom-25"
        faded-sides
        slides-auto-height
        slides-overflow-visible
    >
        ${dummyEvents.map((teaser, index) => {
            if (index > 4) return;
            return html` <ux-slider-slide class="ux-u-margin-top-25">
                ${TeaserEventTemplate(teaser)}
            </ux-slider-slide>`;
        })}
        <ux-slider-slide class="ux-u-margin-top-25">
            ${ViewAllBlockTemplate({
                icon: "calendar",
                tab: tab,
                text: "Alle Ergebnisse anzeigen",
            })}
        </ux-slider-slide>
        <ux-slider-pagination
            slot="pagination"
            bottom-pagination
        ></ux-slider-pagination>
    </ux-slider>
`;
